// word-reveal.directive.ts
import {
    Directive,
    ElementRef,
    AfterViewInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

@Directive({
    selector: '[appWordReveal]',
    standalone: false
})
export class WordRevealDirective implements AfterViewInit {
    @Input() wordDelay = 200;            // ms between each word
    @Output() finished = new EventEmitter<void>();

    constructor(private el: ElementRef<HTMLElement>) { }

    ngAfterViewInit() {
        const host = this.el.nativeElement;
        const items = Array.from(host.querySelectorAll('li')) as HTMLElement[];
        const allWordSpans: HTMLElement[] = [];
        const iconReveal: { icon: HTMLElement; idx: number }[] = [];
        let globalIdx = 0;

        // wrap every word in a span and hide icons
        items.forEach(item => {
            const icon = item.querySelector('mat-icon[matListIcon]') as HTMLElement;
            icon.classList.add('word-hidden');

            const line = item.querySelector('[matLine]') as HTMLElement;
            const words = (line.textContent || '').trim().split(/\s+/);
            line.innerHTML = '';

            words.forEach((w, wi) => {
                const span = document.createElement('span');
                span.textContent = w + (wi < words.length - 1 ? '\u00A0' : '');
                span.classList.add('word-hidden');
                line.appendChild(span);

                if (wi === 0) {
                    iconReveal.push({ icon, idx: globalIdx });
                }

                allWordSpans.push(span);
                globalIdx++;
            });
        });

        const total = allWordSpans.length;

        // reveal each word in turn
        allWordSpans.forEach((span, i) => {
            setTimeout(() => {
                span.classList.add('word-visible');
                // if this was the last word, emit finished
                if (i === total - 1) {
                    this.finished.emit();
                }
            }, i * this.wordDelay);
        });

        // reveal icons when their first word goes out
        iconReveal.forEach(({ icon, idx }) => {
            setTimeout(() => icon.classList.add('word-visible'), idx * this.wordDelay);
        });
    }
}